module.exports = __webpack_public_path__ + "img/logo14.7f2495d0.png";